export default {
    meta: {
        title: '员工'
    }
};
